export default __webpack_public_path__ + "static/media/Reserve-Pool.d4611ed9.png";